import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';
import type { UnclassifiedEmail, PaginatedResponse } from '@estimator/shared';

export function useUnclassifiedEmails() {
  return useQuery({
    queryKey: ['unclassified-emails'],
    queryFn: async () => {
      const { data } = await apiClient.get<PaginatedResponse<UnclassifiedEmail>>('/admin/unclassified-emails');
      return data;
    },
  });
}

export function useClassifyEmail() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, project_id }: { id: string; project_id: string }) => {
      const { data } = await apiClient.post(
        `/admin/unclassified-emails/${id}/classify`,
        { project_id },
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['unclassified-emails'] });
    },
  });
}

export function useDiscardEmail() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await apiClient.post(`/admin/unclassified-emails/${id}/discard`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['unclassified-emails'] });
    },
  });
}
